function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import stringify from 'fast-json-stable-stringify';
import { isObject, isString } from 'vega-util';
import { dateTimeExprToExpr } from './datetime';
import { accessPathWithDatum, keys, varName } from './util';
/** Time Unit that only corresponds to only one part of Date objects. */

export var LOCAL_SINGLE_TIMEUNIT_INDEX = {
  year: 1,
  quarter: 1,
  month: 1,
  week: 1,
  day: 1,
  dayofyear: 1,
  date: 1,
  hours: 1,
  minutes: 1,
  seconds: 1,
  milliseconds: 1
};
export var TIMEUNIT_PARTS = keys(LOCAL_SINGLE_TIMEUNIT_INDEX);
export function isLocalSingleTimeUnit(timeUnit) {
  return !!LOCAL_SINGLE_TIMEUNIT_INDEX[timeUnit];
}
export var UTC_SINGLE_TIMEUNIT_INDEX = {
  utcyear: 1,
  utcquarter: 1,
  utcmonth: 1,
  utcweek: 1,
  utcday: 1,
  utcdayofyear: 1,
  utcdate: 1,
  utchours: 1,
  utcminutes: 1,
  utcseconds: 1,
  utcmilliseconds: 1
};
export var LOCAL_MULTI_TIMEUNIT_INDEX = {
  yearquarter: 1,
  yearquartermonth: 1,
  yearmonth: 1,
  yearmonthdate: 1,
  yearmonthdatehours: 1,
  yearmonthdatehoursminutes: 1,
  yearmonthdatehoursminutesseconds: 1,
  yearweek: 1,
  yearweekday: 1,
  yearweekdayhours: 1,
  yearweekdayhoursminutes: 1,
  yearweekdayhoursminutesseconds: 1,
  yeardayofyear: 1,
  quartermonth: 1,
  monthdate: 1,
  monthdatehours: 1,
  monthdatehoursminutes: 1,
  monthdatehoursminutesseconds: 1,
  weekday: 1,
  weeksdayhours: 1,
  weekdayhoursminutes: 1,
  weekdayhoursminutesseconds: 1,
  dayhours: 1,
  dayhoursminutes: 1,
  dayhoursminutesseconds: 1,
  hoursminutes: 1,
  hoursminutesseconds: 1,
  minutesseconds: 1,
  secondsmilliseconds: 1
};
export var UTC_MULTI_TIMEUNIT_INDEX = {
  utcyearquarter: 1,
  utcyearquartermonth: 1,
  utcyearmonth: 1,
  utcyearmonthdate: 1,
  utcyearmonthdatehours: 1,
  utcyearmonthdatehoursminutes: 1,
  utcyearmonthdatehoursminutesseconds: 1,
  utcyearweek: 1,
  utcyearweekday: 1,
  utcyearweekdayhours: 1,
  utcyearweekdayhoursminutes: 1,
  utcyearweekdayhoursminutesseconds: 1,
  utcyeardayofyear: 1,
  utcquartermonth: 1,
  utcmonthdate: 1,
  utcmonthdatehours: 1,
  utcmonthdatehoursminutes: 1,
  utcmonthdatehoursminutesseconds: 1,
  utcweekday: 1,
  utcweeksdayhours: 1,
  utcweekdayhoursminutes: 1,
  utcweekdayhoursminutesseconds: 1,
  utcdayhours: 1,
  utcdayhoursminutes: 1,
  utcdayhoursminutesseconds: 1,
  utchoursminutes: 1,
  utchoursminutesseconds: 1,
  utcminutesseconds: 1,
  utcsecondsmilliseconds: 1
};
export function isUTCTimeUnit(t) {
  return t.startsWith('utc');
}
export function getLocalTimeUnit(t) {
  return t.substr(3);
} // In order of increasing specificity

export var VEGALITE_TIMEFORMAT = {
  'year-month': '%b %Y ',
  'year-month-date': '%b %d, %Y '
};
export function getTimeUnitParts(timeUnit) {
  var parts = [];

  var _iterator = _createForOfIteratorHelper(TIMEUNIT_PARTS),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;

      if (containsTimeUnit(timeUnit, part)) {
        parts.push(part);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return parts;
}
/** Returns true if fullTimeUnit contains the timeUnit, false otherwise. */

export function containsTimeUnit(fullTimeUnit, timeUnit) {
  var index = fullTimeUnit.indexOf(timeUnit);

  if (index < 0) {
    return false;
  } // exclude milliseconds


  if (index > 0 && timeUnit === 'seconds' && fullTimeUnit.charAt(index - 1) === 'i') {
    return false;
  } // exclude dayofyear


  if (fullTimeUnit.length > index + 3 && timeUnit === 'day' && fullTimeUnit.charAt(index + 3) === 'o') {
    return false;
  }

  if (index > 0 && timeUnit === 'year' && fullTimeUnit.charAt(index - 1) === 'f') {
    return false;
  }

  return true;
}
/**
 * Returns Vega expression for a given timeUnit and fieldRef
 */

export function fieldExpr(fullTimeUnit, field) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    end: false
  },
      end = _ref.end;

  var fieldRef = accessPathWithDatum(field);
  var utc = isUTCTimeUnit(fullTimeUnit) ? 'utc' : '';

  function func(timeUnit) {
    if (timeUnit === 'quarter') {
      // quarter starting at 0 (0,3,6,9).
      return "(".concat(utc, "quarter(").concat(fieldRef, ")-1)");
    } else {
      return "".concat(utc).concat(timeUnit, "(").concat(fieldRef, ")");
    }
  }

  var lastTimeUnit;
  var dateExpr = {};

  var _iterator2 = _createForOfIteratorHelper(TIMEUNIT_PARTS),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var part = _step2.value;

      if (containsTimeUnit(fullTimeUnit, part)) {
        dateExpr[part] = func(part);
        lastTimeUnit = part;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (end) {
    dateExpr[lastTimeUnit] += '+1';
  }

  return dateTimeExprToExpr(dateExpr);
}
export function timeUnitSpecifierExpression(timeUnit) {
  if (!timeUnit) {
    return undefined;
  }

  var timeUnitParts = getTimeUnitParts(timeUnit);
  return "timeUnitSpecifier(".concat(stringify(timeUnitParts), ", ").concat(stringify(VEGALITE_TIMEFORMAT), ")");
}
/**
 * Returns the signal expression used for axis labels for a time unit.
 */

export function formatExpression(timeUnit, field, isUTCScale) {
  if (!timeUnit) {
    return undefined;
  }

  var expr = timeUnitSpecifierExpression(timeUnit); // We only use utcFormat for utc scale
  // For utc time units, the data is already converted as a part of timeUnit transform.
  // Thus, utc time units should use timeFormat to avoid shifting the time twice.

  var utc = isUTCScale || isUTCTimeUnit(timeUnit);
  return "".concat(utc ? 'utc' : 'time', "Format(").concat(field, ", ").concat(expr, ")");
}
export function normalizeTimeUnit(timeUnit) {
  if (!timeUnit) {
    return undefined;
  }

  var params;

  if (isString(timeUnit)) {
    params = {
      unit: timeUnit
    };
  } else if (isObject(timeUnit)) {
    params = Object.assign(Object.assign({}, timeUnit), timeUnit.unit ? {
      unit: timeUnit.unit
    } : {});
  }

  if (isUTCTimeUnit(params.unit)) {
    params.utc = true;
    params.unit = getLocalTimeUnit(params.unit);
  }

  return params;
}
export function timeUnitToString(tu) {
  var _a = normalizeTimeUnit(tu),
      utc = _a.utc,
      rest = __rest(_a, ["utc"]);

  if (rest.unit) {
    return (utc ? 'utc' : '') + keys(rest).map(function (p) {
      return varName("".concat(p === 'unit' ? '' : "_".concat(p, "_")).concat(rest[p]));
    }).join('');
  } else {
    // when maxbins is specified instead of units
    return (utc ? 'utc' : '') + 'timeunit' + keys(rest).map(function (p) {
      return varName("_".concat(p, "_").concat(rest[p]));
    }).join('');
  }
}